import Vue from "vue";
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import Login from "@/views/Login.vue";
import { requireAuth, redirectIfAuthenticated } from "./guards";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Login",
    component: Login,
    beforeEnter: redirectIfAuthenticated,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "@/views/ForgotPassword.vue"
      ),
    beforeEnter: redirectIfAuthenticated,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "@/views/ResetPassword.vue"
      ),
    props: (route) => ({ token: route.query.token }),
    beforeEnter: redirectIfAuthenticated,
  },
  {
    path: "/splash",
    name: "Splash Screen",
    component: () =>
      import(/* webpackChunkName: "splash" */ "@/views/Splash.vue"),
    beforeEnter: (to, from, next) => {
      if (to.fullPath === "/splash") next("/");
      else next();
    },
  },
  {
    path: "/dashboard",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue"
      ),
    beforeEnter: requireAuth,
    children: [
      {
        path: "",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/Dashboard/Home.vue"),
      },
      {
        path: "tools",
        component: () =>
          import(
            /* webpackChunkName: "tools" */ "@/views/Dashboard/Tools/Tools.vue"
          ),
        children: [
          {
            path: "",
            name: "Tools",
            component: () =>
              import(
                /* webpackChunkName: "tools" */ "@/views/Dashboard/Tools/ToolsHome.vue"
              ),
          },
          {
            path: "pulse",
            name: "Pulse",
            component: () =>
              import(
                /* webpackChunkName: "pulse" */ "@/views/Dashboard/Tools/Pulse.vue"
              ),
          },
          {
            path: "ruler",
            name: "Ruler",
            component: () =>
              import(
                /* webpackChunkName: "ruler" */ "@/views/Dashboard/Tools/Ruler.vue"
              ),
          },
          {
            path: "aqc",
            name: "AQC",
            component: () =>
              import(
                /* webpackChunkName: "aqc" */ "@/views/Dashboard/Tools/AQC.vue"
              ),
          },
          {
            path: "pco",
            name: "PCO",
            component: () =>
              import(
                /* webpackChunkName: "pco" */ "@/views/Dashboard/Tools/PCO.vue"
              ),
          },
          {
            path: "av360",
            name: "AV360",
            component: () =>
              import(
                /* webpackChunkName: "av360" */ "@/views/Dashboard/Tools/AV360.vue"
              ),
          },
        ],
      },
      {
        path: "account",
        name: "Account",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "@/views/Dashboard/Account.vue"
          ),
      },
    ],
  },
  {
    path: "/heart",
    name: "Heart",
    component: () =>
      import(/* webpackChunkName: "heart" */ "@/views/Heart.vue"),
  },
  {
    path: "/form/:id",
    name: "Form",
    component: () => import(/* webpackChunkName: "form" */ "@/views/Form.vue"),
    props: (route) => ({ formId: route.params.id }),
    beforeEnter: requireAuth,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
